export const FEEDBACK = '/feedback/' as const
export const FEEDBACK_ALL = `${FEEDBACK}all` as const
export const FEEDBACK_EDIT = `${FEEDBACK}edit` as const
export const FEEDBACK_STATUS = `${FEEDBACK}status/` as const
export const FEEDBACK_TYPES = `${FEEDBACK}types` as const
export const FEEDBACK_UPDATE = `${FEEDBACK}update` as const

export const FEEDBACK_FORM = '/feedback_form/' as const
export const FEEDBACK_FORM_ALL = `${FEEDBACK_FORM}all` as const
